export enum TrainingStatus {
  IN_APPROVAL = 'in_approval',
  WAITING_LIST = 'in_waiting_list',
}

export enum TrainingAvailability {
  DRAFT = 'draft',
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  PENDING_PUBLISHING_APPROVAL = 'pending_publishing_approval',
}

export enum TrainingSortPosition {
  FIRST = 0,
  SECOND = 1,
  THIRD = 2,
}
